module.exports = __webpack_public_path__ + "e4dd5eb2e39a2e5c1c600f458bf29efe.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_1-872.jpg
// module id = 572
// module chunks = 0